import FileLink from './FileLink';

export default FileLink;
